var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16683 7.76665L2.16683 3.23331C2.16683 2.23331 2.5935 1.83331 3.6535 1.83331L6.34683 1.83331C7.40683 1.83331 7.8335 2.23331 7.8335 3.23331L7.8335 7.76665C7.8335 8.76665 7.40683 9.16665 6.34683 9.16665H3.6535C2.5935 9.16665 2.16683 8.76665 2.16683 7.76665Z",
    fill: "#8C8A96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16683 13.7667L2.16683 11.9C2.16683 10.9 2.5935 10.5 3.6535 10.5H6.34683C7.40683 10.5 7.8335 10.9 7.8335 11.9L7.8335 13.7667C7.8335 14.7667 7.40683 15.1667 6.34683 15.1667H3.6535C2.5935 15.1667 2.16683 14.7667 2.16683 13.7667Z",
    fill: "#8C8A96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16683 5.09998V3.23331C9.16683 2.23331 9.5935 1.83331 10.6535 1.83331L13.3468 1.83331C14.4068 1.83331 14.8335 2.23331 14.8335 3.23331V5.09998C14.8335 6.09998 14.4068 6.49998 13.3468 6.49998L10.6535 6.49998C9.5935 6.49998 9.16683 6.09998 9.16683 5.09998Z",
    fill: "#8C8A96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.9V12L11.6 12.7M9.5 12C9.5 13.933 11.067 15.5 13 15.5C14.933 15.5 16.5 13.933 16.5 12C16.5 10.067 14.933 8.5 13 8.5C11.067 8.5 9.5 10.067 9.5 12Z",
    stroke: "#8C8A96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectBlock);
export default __webpack_public_path__ + "static/media/Select_block.9cbd4485dbcf9daf5462e312a4234057.svg";
export { ForwardRef as ReactComponent };